module.exports = __webpack_public_path__ + "static/media/iconpro-cal-click.c67f58ec.png";